// Generated by CoffeeScript 1.8.0
(function() {
  var Request;

  Request = (function() {
    function Request(type, async) {
      this.type = type != null ? type : 'GET';
      this.async = async != null ? async : true;
      return;
    }

    Request.prototype.prepare = function(type, url, async) {
      this.type = type != null ? type : "GET";
      this.url = url;
      this.async = async != null ? async : true;
      return this;
    };

    Request.prototype.sendRequest = function(parameters, jsonResponse) {
      var async, type, url;
      if (parameters == null) {
        parameters = null;
      }
      if (jsonResponse == null) {
        jsonResponse = false;
      }
      type = this.type;
      url = this.url;
      async = this.async;
      return new Promise(function(resolve, reject) {
        var request;
        request = new XMLHttpRequest();
        if (parameters !== null) {
          if (type === 'GET') {
            url = url + "?" + parameters;
          }
        }
        request.open(type, url, async);
        request.setRequestHeader("X-Requested-With", "XMLHttpRequest");
        request.onload = function() {
          if (request.status >= 200 && request.status < 400) {
            if (jsonResponse) {
              resolve(JSON.parse(request.responseText));
            } else {
              resolve(request.responseText);
            }
          } else {
            reject(Error(request.statusText));
          }
        };
        request.onerror = function() {};
        request.send();
      });
    };

    return Request;

  })();

  window.Request = Request;

}).call(this);


